import { useAuthStore } from "@/stores/auth";
import { App } from "vue";

function someOf(subset: string[], array: string[]): boolean {
  return subset.some((element) => array.includes(element));
}

function allOf(subset: string[], array: string[]): boolean {
  return subset.every((element) => array.includes(element));
}

type Permission = string;

// Plugin Definition
const permissions = {
  install: (app: App) => {
    /**
     * Directive to check if a user has permission to perform an action
     * @param {Array} value - List of actions to check e.g. ['READ','READ_WRITE']
     * @param {Object} modifiers - List of domains to check e.g. persons
     * @param {String} arg - "all" or "one" to determine if all or one permission is required
     *                        default is "all"
     * @example: v-can:one.persons="['READ','READ_WRITE']"
     * @example: v-can.persons="['READ_WRITE']"
     */
    app.directive("can", {
      mounted: (el: HTMLElement, binding) => {
        const { value, modifiers, arg } = binding;
        const authStore = useAuthStore();

        if (authStore.isAuthenticated()) {
          const permissionList: Permission[] = [];
          let passed = false;

          const userPermissions = authStore.permissions;
          console.log("userPermissions", userPermissions);

          // Generate a list of permissions to check
          Object.keys(modifiers).forEach((domain: string) => {
            value.forEach((action: string) => {
              permissionList.push([domain, action].join(":"));
            });
          });

          // Check directive argument to see if any or all permissions are required
          switch (arg) {
            case "one":
              passed = someOf(permissionList, userPermissions || {});
              break;
            case "all":
            default:
              passed = allOf(permissionList, userPermissions);
              break;
          }

          // No permission, remove element
          if (!passed) {
            el.parentNode && el.parentNode.removeChild(el);
          }
        }
      },
    });
  },
};

export default permissions;
